module.exports = __webpack_public_path__ + "static/media/salonrandevu_qr.83348b36.png";